import React from 'react';
import { ROUTE } from 'constant';
import Shared from 'screens/shared';
import Groups from './groups';

export default () => (
  <Shared.widgets.Page route={ROUTE.DASHBOARD.AUTO_SCALING} isStrap={false}>
    <Groups.List />
  </Shared.widgets.Page>
);
